import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, Text, Spinner, Input, MessageBar, MessageBarBody, Badge, Card, CardHeader, } from "@fluentui/react-components";
import { SearchRegular, PeopleTeamRegular } from "@fluentui/react-icons";
import { useAuth } from "../../../context/AuthContext";
import { getAllEmployees, getAllApprobateurs, isSalarie } from "../../../services/dataService";
const svc = (e) => (e.extensionAttribute3 || e.department || "").trim();
export const ManagerEquipeMembres = () => {
    const { apiToken: accessToken, userEmail } = useAuth();
    const [team, setTeam] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState("");
    useEffect(() => {
        if (!accessToken || !userEmail)
            return;
        (async () => {
            setLoading(true);
            setError(null);
            try {
                const me = userEmail.toLowerCase();
                const [emps, approbateurs] = await Promise.all([
                    getAllEmployees(accessToken),
                    getAllApprobateurs(accessToken),
                ]);
                // B-62+B-56: subordonnés directs via managerMail Entra
                let memb = emps.filter((e) => isSalarie(e.extensionAttribute1)
                    && (e.managerMail || "").toLowerCase() === me);
                // Fallback si aucun subordonné direct via managerMail
                if (memb.length === 0) {
                    const mesServices = new Set();
                    for (const a of approbateurs) {
                        const e1 = (a.employeeEmail || "").toLowerCase();
                        const e2 = (a.approbateur2Email || "").toLowerCase();
                        if ((e1 === me || e2 === me) && a.service)
                            mesServices.add(a.service.trim());
                    }
                    if (mesServices.size === 0) {
                        const myProfile = emps.find((e) => (e.mail || "").toLowerCase() === me);
                        const myDept = svc(myProfile);
                        if (myDept)
                            mesServices.add(myDept);
                    }
                    memb = emps.filter((e) => isSalarie(e.extensionAttribute1)
                        && mesServices.has(svc(e))
                        && (e.mail || "").toLowerCase() !== me);
                }
                const servicesSet = new Set(memb.map((e) => svc(e)).filter(Boolean));
                setServices(Array.from(servicesSet));
                setTeam(memb);
            }
            catch (e) {
                setError(e.message);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [accessToken, userEmail]);
    const filtered = useMemo(() => {
        const q = search.trim().toLowerCase();
        if (!q)
            return team;
        return team.filter((e) => (e.displayName || "").toLowerCase().includes(q) ||
            (e.mail || "").toLowerCase().includes(q) ||
            (e.jobTitle || "").toLowerCase().includes(q) ||
            svc(e).toLowerCase().includes(q));
    }, [team, search]);
    if (loading)
        return _jsx(Spinner, { label: "Chargement des membres..." });
    if (error)
        return _jsx(MessageBar, { intent: "error", children: _jsx(MessageBarBody, { children: error }) });
    return (_jsxs("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [_jsxs("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }, children: [_jsxs(Text, { size: 500, weight: "semibold", children: [_jsx(PeopleTeamRegular, { style: { verticalAlign: "middle", marginRight: 6 } }), "Membres de mon \u00E9quipe (", team.length, ")"] }), _jsx(Input, { contentBefore: _jsx(SearchRegular, {}), placeholder: "Rechercher...", value: search, onChange: (_, d) => setSearch(d.value), style: { minWidth: 260 } })] }), services.length > 0 && (_jsxs("div", { style: { display: "flex", gap: 6, flexWrap: "wrap" }, children: [_jsx(Text, { size: 200, style: { color: "#666" }, children: "Services couverts :" }), services.map((s) => _jsx(Badge, { appearance: "outline", color: "brand", children: s }, s))] })), team.length === 0 ? (_jsx(Card, { children: _jsx(CardHeader, { header: _jsx(Text, { weight: "semibold", children: "Aucun membre rattach\u00E9" }), description: _jsx(Text, { children: services.length === 0
                            ? "Aucun service n'est associé à votre compte dans la liste des Approbateurs. Contactez le service RH."
                            : "Aucun salarié actif dans vos services." }) }) })) : (_jsxs(Table, { size: "small", children: [_jsx(TableHeader, { children: _jsxs(TableRow, { children: [_jsx(TableHeaderCell, { children: "Nom" }), _jsx(TableHeaderCell, { children: "Poste" }), _jsx(TableHeaderCell, { children: "Service" }), _jsx(TableHeaderCell, { children: "Lieu" }), _jsx(TableHeaderCell, { children: "Email" }), _jsx(TableHeaderCell, { children: "Statut" })] }) }), _jsx(TableBody, { children: filtered.map((e) => (_jsxs(TableRow, { children: [_jsx(TableCell, { children: _jsx(Text, { weight: "semibold", children: e.displayName }) }), _jsx(TableCell, { children: e.jobTitle || "—" }), _jsx(TableCell, { children: svc(e) || "—" }), _jsx(TableCell, { children: e.officeLocation || "—" }), _jsx(TableCell, { children: e.mail || "—" }), _jsx(TableCell, { children: _jsx(Badge, { appearance: "outline", color: e.accountEnabled ? "success" : "danger", children: e.accountEnabled ? "Actif" : "Désactivé" }) })] }, e.id))) })] }))] }));
};
